export default __webpack_public_path__ + "static/media/tituloES.df92e908.png";